import React from "react";
import { useHistory } from "react-router-dom";
import banner from "../../../assets/images/Carousel/c4.png";
import "./BannerCta.css";

// 🔧 set where this banner links to (internal route or external URL)
const LINK = "/software-download";

const BannerCta = () => {
  const history = useHistory();
  const go = () => {
    if (!LINK) return;
    if (/^https?:\/\//i.test(LINK)) window.open(LINK, "_blank", "noopener");
    else history.push(LINK);
  };

  return (
    <section className="banner-cta" onClick={go} role="link" tabIndex={0}
      onKeyDown={(e) => { if (e.key === "Enter") go(); }}>
      <img src={banner} alt="" className="banner-cta-img" draggable="false" />
    </section>
  );
};

export default BannerCta;
